import { render, staticRenderFns } from "./ApplicantShowResubmissions.vue?vue&type=template&id=670db2e3&"
import script from "./ApplicantShowResubmissions.vue?vue&type=script&lang=js&"
export * from "./ApplicantShowResubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports